export class CompletedAddress {
  constructor(
    public readonly postcode: string|null,
    public readonly number: number|null,
    public readonly street: string|null,
    public readonly city: string|null,
  ) {
  }

  static fromJson(json: any): CompletedAddress {
    return new CompletedAddress(
      json["zipcode"],
      json["number"],
      json["street"],
      json["city"],
    )
  }
}